import { render, staticRenderFns } from "./Appbar.vue?vue&type=template&id=05f3f1c4&scoped=true&"
import script from "./Appbar.vue?vue&type=script&lang=js&"
export * from "./Appbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f3f1c4",
  null
  
)

export default component.exports